import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/set-d2c.png'
import _imports_1 from '@/assets/image/set-b2b.png'


const _withScopeId = n => (_pushScopeId("data-v-4a688882"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter" }
const _hoisted_2 = { class: "flex-col" }
const _hoisted_3 = { class: "flex-col" }
const _hoisted_4 = {
  key: 0,
  style: {"color":"#aaa","font-size":"12px"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "flex-ter" }
const _hoisted_10 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_0,
  style: {"margin-left":"30px"},
  class: "order-tag"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  referrerPolicy: "no-referrer",
  src: _imports_1,
  style: {"margin-left":"30px"},
  class: "order-tag"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

import { t } from '@/plugins/i18n'
import { ref, nextTick } from 'vue'
import { isD2C, useSite, useRtAffix } from '@/store'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import ProductStats from './ProductStats.vue'
import ProductSku from './ProductSku.vue'
import { combinationStatusDict } from '../data'


export default /*#__PURE__*/_defineComponent({
  props: {
  dataList: {
    type: Array,
    default: () => []
  },
  type: {
    type: String,
    default: ''
  },
  columns: {
    type: Array,
    default: () => []
  },
  tableConfig: {
    type: Object,
    default: () => ({})
  },
  // 是否默认全选
  isAllSelect: {
    type: Boolean,
    default: true
  },
  isChoice: {
    type: Boolean,
    default: false
  }
},
  emits: ['selectionChange'],
  setup(__props, { expose, emit }) {

const props = __props
const imgHeader = 'https://static-s.theckb.com/BusinessMarket/Client/fund/split-'




const STableRef = ref()
const toggleAll = () => {
  nextTick(() => {
    if (!props.isAllSelect) return
    STableRef.value.toggleAllSelection()
    STableRef.value.expandAllChange()
  })
}
expose({
  toggleAll
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(STable, {
    class: "productTable",
    ref: (_value, _refs) => {
      _refs['STableRef'] = _value
      STableRef.value = _value
    },
    "table-data": __props.dataList,
    columns: __props.columns,
    tableConfig: __props.tableConfig,
    showPagination: false,
    onSelectionChange: _cache[0] || (_cache[0] = ($event: any) => (emit('selectionChange', $event))),
    onDataListener: _cache[1] || (_cache[1] = ($event: any) => (toggleAll()))
  }, _createSlots({
    expand: _withCtx(({ scope }) => [
      _createVNode(STable, {
        class: "combinationTable",
        "table-data": scope.row.combinationOrderItemList,
        columns: __props.columns,
        tableConfig: __props.tableConfig,
        showPagination: false
      }, {
        shoppingInfo: _withCtx(({row}) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(ShoppingPreview, {
              image: row.productSkuImg || row.productMainImg || '',
              name: row.productTitleJp || '',
              url: row.productDetailUrl || undefined
            }, null, 8, ["image", "name", "url"])
          ])
        ]),
        productSku: _withCtx(({row}) => [
          row
            ? (_openBlock(), _createBlock(ProductSku, {
                key: 0,
                row: row
              }, null, 8, ["row"]))
            : _createCommentVNode("", true)
        ]),
        productPropertiesName: _withCtx(({row}) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
            return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
          }), 128))
        ]),
        shoppingStats: _withCtx(({row}) => [
          _createVNode(ProductStats, { row: row }, null, 8, ["row"])
        ]),
        cancel: _withCtx(({row}) => [
          _createVNode(_component_el_input, {
            modelValue: row.orderQuantity,
            "onUpdate:modelValue": ($event: any) => ((row.orderQuantity) = $event),
            disabled: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        orderQuantity: _withCtx(({row}) => [
          _createTextVNode(_toDisplayString(row.orderQuantity) + " " + _toDisplayString(row.spotCheckQuantity && row.spotCheckQuantity > 0 ? `(${_unref(t)('抽检')})` : ''), 1)
        ]),
        _: 2
      }, 1032, ["table-data", "columns", "tableConfig"])
    ]),
    orderQuantity: _withCtx(({row}) => [
      _createTextVNode(_toDisplayString(row.orderQuantity) + " " + _toDisplayString(row.spotCheckQuantity && row.spotCheckQuantity > 0 ? `(${_unref(t)('抽检')})` : ''), 1)
    ]),
    shoppingInfo: _withCtx(({row}) => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(ShoppingPreview, {
          image: row.productSkuImg || row.productMainImg || '',
          name: row.productTitleJp || '',
          url: row.productDetailUrl || undefined
        }, null, 8, ["image", "name", "url"]),
        (row.productType === 3 && _unref(isD2C)())
          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
          : _createCommentVNode("", true),
        (row.priorityShippingStatus  && _unref(isD2C)())
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              referrerPolicy: "no-referrer",
              src: `${imgHeader}d2c-${_unref(useSite)()}.png`,
              style: {"margin-left":"30px"},
              class: "order-tag"
            }, null, 8, _hoisted_11))
          : _createCommentVNode("", true),
        (row.productType === 3  && !_unref(isD2C)())
          ? (_openBlock(), _createElementBlock("img", _hoisted_12))
          : _createCommentVNode("", true),
        (row.priorityShippingStatus  && !_unref(isD2C)())
          ? (_openBlock(), _createElementBlock("img", {
              key: 3,
              referrerPolicy: "no-referrer",
              src: `${imgHeader}b2b-${_unref(useSite)()}.png`,
              style: {"margin-left":"30px"},
              class: "order-tag"
            }, null, 8, _hoisted_13))
          : _createCommentVNode("", true)
      ])
    ]),
    productSku: _withCtx(({row}) => [
      row
        ? (_openBlock(), _createBlock(ProductSku, {
            key: 0,
            row: row
          }, null, 8, ["row"]))
        : _createCommentVNode("", true)
    ]),
    productPropertiesName: _withCtx(({row}) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
        return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
      }), 128))
    ]),
    shoppingStats: _withCtx(({row}) => [
      (row.productType === 3)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(combinationStatusDict)[row.combinationStatus]), 1))
        : (_openBlock(), _createBlock(ProductStats, {
            key: 1,
            row: row
          }, null, 8, ["row"]))
    ]),
    cancel: _withCtx(({row}) => [
      _createVNode(_component_el_input, {
        modelValue: row.orderQuantity,
        "onUpdate:modelValue": ($event: any) => ((row.orderQuantity) = $event),
        disabled: ""
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ]),
    actualProductSellPrice: _withCtx(({row}) => [
      (!__props.isChoice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(row.actualProductSellPrice), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(row.allIncludePriceResultDetail?.allIncludeProductPriceExchange) + "円(" + _toDisplayString(row.allIncludePriceResultDetail?.allIncludeProductPrice) + "元)", 1))
    ]),
    _: 2
  }, [
    (!!__props.type)
      ? {
          name: "shopName",
          fn: _withCtx(({row}) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, _toDisplayString(row.shopName), 1),
                _createElementVNode("div", _hoisted_3, [
                  (row.brandHasReleased===1 && row.brandStatus!==2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _hoisted_5,
                        _createVNode(_component_el_tag, { type: "info" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('品牌已下架')), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_6
                      ]))
                    : (row.brandAuthStatus===0&&row.brandHasReleased===1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (row.isAuthorizing)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 0,
                                type: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('申请中')), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_el_tag, { type: "warning" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('未授权_')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("a", {
                                  href: _unref(useRtAffix)()+`brandauth?brand=${row.brandId}`,
                                  class: "empower-a"
                                }, _toDisplayString(_unref(t)('前往授权>')), 9, _hoisted_8)
                              ], 64))
                        ]))
                      : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        }
      : undefined
  ]), 1032, ["table-data", "columns", "tableConfig"]))
}
}

})